import { render } from "./upsertCitizenshipDocumentDialog.vue?vue&type=template&id=af4f7178"
import script from "./upsertCitizenshipDocumentDialog.vue?vue&type=script&lang=js"
export * from "./upsertCitizenshipDocumentDialog.vue?vue&type=script&lang=js"

import "./upsertCitizenshipDocumentDialog.vue?vue&type=style&index=0&id=af4f7178&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__